import { WidgetCard } from 'src/v2/components/widget-card'
import { Colors } from 'src/components/theme'
import { AcquisitionHistoryFilters } from 'src/v2/views/owner-reveal/insights/acquisition-history/activity-feed/filters'
import { AcquisitionHistoryList } from 'src/v2/views/owner-reveal/insights/acquisition-history/activity-feed/list'

export const AcquisitionHistory = () => {
  return (
    <WidgetCard
      id="acquisition-history"
      title="Acquisition History"
      headerBgColor={Colors.primaryRed700}
      headerTextColor={Colors.textWhite}
      filters={<AcquisitionHistoryFilters />}
      sections={[
        {
          content: <AcquisitionHistoryList />,
        },
      ]}
    />
  )
}
